<template>
  <ODialog
    ref="dialog"
    :title="$t('general.delete')"
    :info="$t('components.waitlist.actions.delete.info')"
    :options="[
      { text: $t('general.back'), type: 'cancel' },
      { text: $t('general.delete'), type: 'confirm', callback: confirm, variant: 'danger' },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Waitlist } from '~/_api/models/waitlist'

interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $bus } = useNuxtApp()

const dialog = ref()
const waitlist = ref<Waitlist | null>(null)

const open = (item: Waitlist) => {
  waitlist.value = item
  dialog.value.open()
}

const confirm = async () => {
  if (!waitlist.value) return

  emit('update:loading', true)

  try {
    const response = await $api.waitlist.delete(waitlist.value)

    if (response.success) {
      emit('update:loading', false)
      emit('success')

      $bus.emit.deleted('Waitlist', waitlist.value)

      $notification.toast({
        title: $i18n.t('general.deleted'),
        text: $i18n.t('components.waitlist.actions.delete.successInfo'),
        variant: 'success',
      })

      return true
    }
  } catch (e) {
    emit('update:loading', false)
    console.log(e)
  }
}

defineExpose({
  open,
})
</script>
